import _ from "lodash";

export const PlayerProperties = {
	ROOT: "player",
	ACTIVITY: "activity",
	ACTIVITIES: "activities",
	ACTIVITIES_LOADED: "activitiesLoaded",
	SESSIONS: "sessions",
	SORTED_SESSIONS: "sortedSessions",
	ACTIVITY_ORIGINAL: "activityOriginal",
	ACTIVITY_IDENTITY_ID: "activityIdentityId",
	HISTORY: "history",
	CHILDREN: "children",
	HISTORY_GEOLOCATION: "historyGeolocation",
	LOGBOOK: "logbook",
	TIME_OUT: "timeOut",
	TIME_IN: "timeIn",
	START_IN_SHOW_MODE: "startInShowMode",
	LISTS: "lists",
	SECTIONS: "sections",
	SHOW_SPINNER: "showSpinner",
	SELECTED_ACTIVITY_ID: "selectedActivityId",
	SELECTED_ACTIVITY_IDENTITY_ID: "selectedActivityIdentityId",
	SELECTED_INSTANCE_ACTIVITY_ID: "selectedInstanceActivityId",
	SHOW_SESSIONS_MODAL: "showSessionsModal",
	LAST_UPDATED_DATE_TIME: "lastUpdatedDateTime",
	SUBMITTED: "submitted",
	GLOBAL_VARS: "globalVars",
	SELECTED: "selected",
	SELECTED_LIST_INDEX: "listIndex",
	SELECTED_SECTION_INDEX: "sectionIndex",
	SELECTED_ITEM_INDEX: "itemIndex",
	VARIABLES: "variables",
	VARIABLE_GROUPS: "variableGroups",
	OVERRIDES: "overrides",
	GUID: "guid",
	NAV_STACK: "navStack",
	RELOAD_ACTIVITIES: "reloadActivities",
	SELECTED_HOME_TAB: "selectedHomeTab",
	ROOT_ACTIVITY_ID: "rootActivityId",
	READ_ONLY: "editable",
	FONTS: "fonts",
	AMBIFI_FONTS_CACHE: "ambifiFontsCache",
	SHOW_NAVIGATION_VIEW: "showNavigationView",
	SHOW_NAVIGATION_VIEW_PLACEMENT: "showNavigationViewPlacement",
	PROMPT_MODAL_MOVE_FORWARD_VISIBLE: "promptModalMoveForwardVisible",
	SKETCH_PAD: "sketchPad",
	SHOW_BARCODE_SCANNER: "showBarcodeScanner"
};

const ACTIVITY_ROOT = ["activity"];
const ACTIVITIES_ROOT = ["activities"];

export default {
	ROOT: [PlayerProperties.ROOT],
	ACTIVITY: [...ACTIVITY_ROOT],
	ACTIVITIES: [...ACTIVITIES_ROOT],
	ACTIVITIES_LOADED: [PlayerProperties.ROOT, PlayerProperties.ACTIVITIES_LOADED],
	SESSIONS: [PlayerProperties.SESSIONS],
	SORTED_SESSIONS: [PlayerProperties.ROOT, PlayerProperties.SORTED_SESSIONS],
	ACTIVITY_ORIGINAL: [PlayerProperties.ROOT, PlayerProperties.ACTIVITY_ORIGINAL],
	ACTIVITY_HISTORY: [...ACTIVITY_ROOT, PlayerProperties.HISTORY],
	ACTIVITY_HISTORY_GEOLOCATION: [...ACTIVITY_ROOT, PlayerProperties.HISTORY_GEOLOCATION],
	ACTIVITY_LOGBOOK: [...ACTIVITY_ROOT, PlayerProperties.LOGBOOK],
	ACTIVITY_LOGBOOK_TIME_OUT: [...ACTIVITY_ROOT, PlayerProperties.LOGBOOK, PlayerProperties.TIME_OUT],
	ACTIVITY_LOGBOOK_TIME_IN: [...ACTIVITY_ROOT, PlayerProperties.LOGBOOK, PlayerProperties.TIME_IN],
	ACTIVITY_START_IN_SHOW_MODE: [...ACTIVITY_ROOT, PlayerProperties.START_IN_SHOW_MODE],
	ACTIVITY_LISTS: [...ACTIVITY_ROOT, PlayerProperties.CHILDREN],
	SHOW_SPINNER: [PlayerProperties.ROOT, PlayerProperties.SHOW_SPINNER],
	SELECTED_ACTIVITY_ID: [PlayerProperties.ROOT, PlayerProperties.SELECTED_ACTIVITY_ID],
	SELECTED_ACTIVITY_IDENTITY_ID: [PlayerProperties.ROOT, PlayerProperties.SELECTED_ACTIVITY_IDENTITY_ID],
	SELECTED_ACTIVITY_INSTANCE_ID: [PlayerProperties.ROOT, PlayerProperties.SELECTED_INSTANCE_ACTIVITY_ID],
	SHOW_SESSIONS_MODAL: [PlayerProperties.ROOT, PlayerProperties.SHOW_SESSIONS_MODAL],
	NAV_STACK: [PlayerProperties.ROOT, PlayerProperties.NAV_STACK],
	RELOAD_ACTIVITIES: [PlayerProperties.ROOT, PlayerProperties.RELOAD_ACTIVITIES],
	SELECTED_HOME_TAB: [PlayerProperties.ROOT, PlayerProperties.SELECTED_HOME_TAB],
	READ_ONLY: [PlayerProperties.ROOT, PlayerProperties.READ_ONLY],	
	ACTIVITY_PROPERTY: (prop) => {
		return [...ACTIVITY_ROOT, prop];
	},
	ACTIVITY_LIST: (listIndex) => {
		return [...ACTIVITY_ROOT, PlayerProperties.CHILDREN, listIndex];
	},
	ACTIVITY_LIST_PROPERTY: (listIndex, prop) => {
		return [...ACTIVITY_ROOT, PlayerProperties.CHILDREN, listIndex, prop];
	},
	ACTIVITY_SECTIONS: (listIndex) => {
		return [...ACTIVITY_ROOT, PlayerProperties.CHILDREN, listIndex, PlayerProperties.CHILDREN];
	},
	ACTIVITY_SECTION: (listIndex, sectionIndex) => {
		return [...ACTIVITY_ROOT, PlayerProperties.CHILDREN, listIndex, PlayerProperties.CHILDREN, sectionIndex];
	},
	ACTIVITY_SECTION_PROPERTY: (listIndex, sectionIndex, prop) => {
		return [...ACTIVITY_ROOT, PlayerProperties.CHILDREN, listIndex, PlayerProperties.CHILDREN, sectionIndex, prop];
	},
	ACTIVITY_ITEMS: (listIndex, sectionIndex) => {
		return [...ACTIVITY_ROOT, PlayerProperties.CHILDREN, listIndex, PlayerProperties.CHILDREN, sectionIndex, PlayerProperties.CHILDREN];
	},
	ACTIVITY_ITEM: (listIndex, sectionIndex, itemIndex) => {
		return [...ACTIVITY_ROOT, PlayerProperties.CHILDREN, listIndex, PlayerProperties.CHILDREN, sectionIndex, PlayerProperties.CHILDREN, itemIndex];
	},
	ACTIVITY_ITEM_PROPERTY: (listIndex, sectionIndex, itemIndex, property) => {
		if (_.isArray(property)) {
			return [...ACTIVITY_ROOT, PlayerProperties.CHILDREN, listIndex, PlayerProperties.CHILDREN, sectionIndex, PlayerProperties.CHILDREN, itemIndex, ...property];
		} else {
			return [...ACTIVITY_ROOT, PlayerProperties.CHILDREN, listIndex, PlayerProperties.CHILDREN, sectionIndex, PlayerProperties.CHILDREN, itemIndex, property];
		}
	},
	SESSIONS_BY_ACTIVITY_ID: (activityId) => {
		return [PlayerProperties.SESSIONS, activityId];
	},
	SESSION_LAST_UPDATED_DATE_TIME: (activityId, idx) => {
		return [PlayerProperties.SESSIONS, activityId, idx, PlayerProperties.LAST_UPDATED_DATE_TIME];
	},
	SESSION_SUBMITTED: (activityId, idx) => {
		return [PlayerProperties.SESSIONS, activityId, idx, PlayerProperties.SUBMITTED];
	},
	GLOBAL_VARS: (name) => {
		return [PlayerProperties.ROOT, PlayerProperties.GLOBAL_VARS, name];
	},
	ACTIVITY_SELECTED_LIST_INDEX: [...ACTIVITY_ROOT, PlayerProperties.SELECTED, PlayerProperties.SELECTED_LIST_INDEX],
	ACTIVITY_SELECTED_SECTION_INDEX: [...ACTIVITY_ROOT, PlayerProperties.SELECTED, PlayerProperties.SELECTED_SECTION_INDEX],
	ACTIVITY_SELECTED_ITEM_INDEX: [...ACTIVITY_ROOT, PlayerProperties.SELECTED, PlayerProperties.SELECTED_ITEM_INDEX],
	ACTIVITY_VARIABLES: [...ACTIVITY_ROOT, PlayerProperties.VARIABLES],
	ACTIVITY_VARIABLE: (guid) => {
		return [...ACTIVITY_ROOT, PlayerProperties.VARIABLES, guid];
	},
	ACTIVITY_VARIABLE_GROUPS: [...ACTIVITY_ROOT, PlayerProperties.VARIABLE_GROUPS],
	ACTIVITY_VARIABLE_GROUP: (groupName) => {
		return [...ACTIVITY_ROOT, PlayerProperties.VARIABLE_GROUPS, groupName];
	},
	ACTIVITY_VARIABLE_GROUP_VARIABLE: (groupName, variable) => {
		return [...ACTIVITY_ROOT, PlayerProperties.VARIABLE_GROUPS, groupName, variable];
	},
	ACTIVITY_OVERRIDES: [...ACTIVITY_ROOT, PlayerProperties.OVERRIDES],
	ACTIVITY_OVERRIDE: (guid) => {
		return [...ACTIVITY_ROOT, PlayerProperties.OVERRIDES, guid];
	},
	ACTIVITY_OVERRIDE_PROPERTY: (guid, prop) => {
		return [...ACTIVITY_ROOT, PlayerProperties.OVERRIDES, guid, prop];
	},
	ROOT_ACTIVITY_ID: [PlayerProperties.ROOT_ACTIVITY_ID],
	AMBIFI_FONTS_CACHE: [PlayerProperties.ROOT, PlayerProperties.FONTS, PlayerProperties.AMBIFI_FONTS_CACHE],
	SHOW_NAVIGATION_VIEW: [PlayerProperties.ROOT, PlayerProperties.SHOW_NAVIGATION_VIEW],
	SHOW_NAVIGATION_VIEW_PLACEMENT: [PlayerProperties.ROOT, PlayerProperties.SHOW_NAVIGATION_VIEW_PLACEMENT],
	PROMPT_MODAL_MOVE_FORWARD_VISIBLE: [PlayerProperties.ROOT, PlayerProperties.PROMPT_MODAL_MOVE_FORWARD_VISIBLE],
	SKETCH_PAD_PROPERTY: (prop) => {
		return [PlayerProperties.ROOT, PlayerProperties.SKETCH_PAD, prop];
	},
	SHOW_BARCODE_SCANNER: [PlayerProperties.ROOT, PlayerProperties.SHOW_BARCODE_SCANNER]
};